<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="filter_headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID" v-bind:class="{ 'warning-line': item.IsFragileGoods || item.IsCheck || item.OrderGuarantee}">
                <td>{{ item.TransactionCode }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                <td><a target="_blank" :href="(item.PackageType == 0 ? '/don-hang/' : '/ky-gui/') + item.OrderID">{{ item.OrderID | pad(4,item.PackageType == 0 ? 'TB' : 'KG')}}</a></td>
                <td v-bind:style="{'color': getChinaStoreColor(item.ChinaStoreID)}">{{ item.ChinaStoreID | display_value(chinaStores, 'ID', 'Name') }}</td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.Weight"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'Weight': item.Weight})"
                  >
                    <div>{{ item.Weight | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.Weight"
                        type="number"
                        step=".1"
                        label="Cân nặng"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.Volume"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'Volume': item.Volume})"
                  >
                    <div>{{ item.Volume | currency('', 2)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.Volume"
                        type="number"
                        step=".01"
                        label="Thể tích"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeShip"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'FeeShip': item.FeeShip})"
                  >
                    <div>{{ item.FeeShip | currency('¥', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeShip"
                        type="number"
                        step=".1"
                        label="Phí ship"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeFragileGoods"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'FeeFragileGoods': item.FeeFragileGoods})"
                  >
                    <div>{{ item.FeeFragileGoods | currency('¥', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeFragileGoods"
                        type="number"
                        step=".1"
                        label="Phí gia cố"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeOther"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'FeeOther': item.FeeOther})"
                  >
                    <div>{{ item.FeeOther | currency('¥', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeOther"
                        type="number"
                        step=".1"
                        label="Phí khác"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>{{ item.StoreCNImportDate | display_date }}</td>
                <td>{{ item.ExDate | display_date }}</td>
                <td>{{ item.Username }}</td>
                <td>
                  {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                  <br v-if="item.IsFragileGoods" />
                  {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                  <br v-if="item.IsCheck" />
                  {{ item.OrderGuarantee ? 'Bảo hiểm' : '' }}
                </td>
                <td class="truncate">
                  <v-edit-dialog :return-value.sync="item.StoreCNNote" large lazy persistent @save="saveItem({'ID': item.ID, 'StoreCNNote': item.StoreCNNote})">
                      <v-tooltip top right max-width="250">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.StoreCNNote }}</span>
                          </template>
                          <span>{{ item.StoreCNNote }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea v-model="item.StoreCNNote" label="Ghi chú" single-line autofocus></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center">
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" v-if="(storeRole & 4)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xóa mã vận đơn</span>
                  </v-tooltip>
                  
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
      <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/nhap_kho_tq.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import { sendErrorNotice } from "@/commons/utils";
import upload_file from "@/components/popups/upload_file";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "store-popup": store,
    "upload-file": upload_file,
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      package_status: configs.PACKAGE_STATUS,
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: dataType["Enum"]
        },
        {
          text: "Mã đơn hàng",
          value: "OrderID",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Number"]
        },
        {
          text: "Kho TQ",
          value: "ChinaStoreID",
          filterable: true,
          values: [],
          dataType: dataType["Enum"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí gia cố",
          value: "FeeFragileGoods",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày nhập kho",
          value: "StoreCNImportDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày xuất kho",
          value: "ExDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Cảnh báo",
          sortable: false,
          filterable: false,
        },
        {
          text: "Ghi chú",
          value: "StoreCNNote",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false,
      dialogImport: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    storeRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    },
    chinaStores() {
      let header_item = _.find(this.headers, { value: "ChinaStoreID" });
      if (header_item) {
        header_item.values =
          _.map(this.chinaStores, (item) => {
            return {
              value: item.ID,
              name: item.Name,
            };
          }) || [];
      }
    },
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading,
      packages: state => state.bigPackage.inTQ,
      guarantees: state => {
        let tmp = [{name: 'Không sử dụng', value: 0}];
        if(state.feeGuarantee.all.data) {
        state.feeGuarantee.all.data.forEach(element => {
            tmp.push({name: element.PackageName, value: element.ID});
        });
        }
        return tmp;
      },
      chinaStores: (state) => state.commons.chinaStores,
    }),
    storeRole() {
      return this.$store.state.authentication.role.StoreCN;
    },
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      pr.filter.push({
        column: "Status",
        value: [configs.PACKAGE_STATUS_ENUM.DA_VE_TQ, configs.PACKAGE_STATUS_ENUM.DANG_VE_VN],
        condition: "in"
      });
      return pr;
    },    
    filter_headers() {
      let tmp = [...this.headers];
      tmp.push({
          text: "Đóng gỗ",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Kiểm hàng",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Bảo hiểm",
          value: "OrderGuarantee",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        });
      return tmp;
    },
  },
  methods: {
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    getChinaStoreColor(store_id) {
      let item = _.find(this.chinaStores, {ID: store_id});
      return item && item.Color ? item.Color : '#000000';
    },
    filter_data: function() {
      this.$store.dispatch("bigPackage/getListInTQ");
      this.$store.dispatch("orderTransaction/getList", this.param);
      this.$store.dispatch("feeGuarantee/getList");
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("orderTransaction/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.storeRole & 2) {
        this.$store.commit("orderTransaction/setDetail", {
          data: {
            ID: 0,
            TransactionCode: "",
            FeeShip: 0
          }
        });
        this.dialogStoreManager = true;
      }
      else {
        sendErrorNotice("Bạn không có quyền thêm mới!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item,
          'TransactionView': 'store_tq'
        },
        id: item.ID,
        param: this.param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    getBigPackage(bigPackageID) {
      const item = _.find(this.packages, {ID: bigPackageID});
      return item ? item.PackageCode : '';
    },
    onImport() {
      this.dialogImport = true;
    },
    importFile(filelist) {
      for(const f of filelist) {
        const formData = new FormData();
        formData.append('excel_file', f);
        formData.append('filename', f.name);
        this.$store.dispatch("storeManager/import_transaction", formData);
      }
      this.dialogImport = false;
    }
  },
  mounted() {
    this.$store.dispatch("commons/getAllChinaStores");
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_OTHER_ACTION", this.onImport);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          'RequestAction': 'DEL',
          'TransactionView': 'store_cn'
        },
        'id': id,
        param: this.param
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_OTHER_ACTION", this.onImport);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
<style scoped>
.warning-line {
  background-color: rgba(250, 117, 117, 0.726);
}
</style>
